<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Purchase Orders" searchable="true"></list-nav-header>


            <filter-bar :filters="filters" class="hidden-mobile"></filter-bar>

            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items">
                        <div class="icon">
                            <i class="fa fa-square red" aria-hidden="true" v-if="item.disputed" title="Disputed"></i>
                            <span v-else>
                                <i class="fa fa-square green" aria-hidden="true" v-if="item.billed" title="Billed"></i>
                            </span>
                        </div>
                        <a :href="item._links.frontend.view" class="info">
                            <span>{{ item.supplier }}</span>
                            <span>{{ item.raised }}</span>
                            <span>{{ item.reference }}</span>
                            <span>{{ item.costs.gross }}</span>
                        </a>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Orders
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">#
                            <sorter table-name="po" field="reference"></sorter>
                        </th>
                        <th scope="col">Status</th>
                        <th scope="col" v-if="view_all">Raised
                            <sorter table-name="po" field="date"></sorter>
                        </th>
                        <th scope="col">Delivery Dates</th>
                        <th scope="col">Package</th>
                        <th scope="col" v-if="view_all">Supplier</th>
                        <th scope="col">Net</th>
                        <th scope="col" v-if="view_all">VAT</th>
                        <th scope="col" v-if="view_all">Gross</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference"><a :href="item._links.frontend.view">{{ item.reference }}</a></td>
                        <td data-label="Status">{{ item.status }}</td>
                        <td data-label="Raised" v-if="view_all">{{ item.raised }}<br />{{ item.created_by.name }}</td>
                        <td data-label="Delivery Dates" v-html="$options.filters.date_col(item.delivery_dates)"></td>
                        <td data-label="Package" v-if="item.package"><a :href="item.package.data._links.frontend.view">{{
                            item.package.data.project }}: {{
                            item.package.data.name }}</a></td>
                        <td data-label="Package" v-else>No Package</td>
                        <td data-label="Supplier" v-if="view_all">{{ item.supplier }}</td>
                        <td data-label="Net">&pound;{{ item.costs.net }}</td>
                        <td data-label="VAT" v-if="view_all">&pound;{{ item.costs.vat }}</td>
                        <td data-label="Gross" v-if="view_all">&pound;{{ item.costs.gross }}</td>
                    </tr>
                    <tr>
                        <td colspan="11">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Orders
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>


            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props: ['compact', 'supplierId', 'supplierType', 'packageId'],
        data() {
            return {
                name: 'pos',
                sort: null,
                items: [],
                nextPaginationUrl: '',
                search_query: null,
                filtered: false,
                statuses: []
            }
        },
        filters: {
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            },
            supplierId: function () {
                this.getItems();
            },
            supplierType: function () {
                this.getItems();
            },
            filtered: function(){
                this.getItems();
            }
        },
        computed: {
            is_filtered(){
                if(this.filtered === false)
                {
                    return false;
                }

                return true;
            },
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            view_all() {
                if (this.compact === true || this.compact == 'true') {
                    return false;
                }

                return true;
            },
            filters: function(){
                var filters = {};
                _.forEach(this.statuses,function(status){
                    filters[status] =  status.charAt(0).toUpperCase() + status.slice(1);
                });
                return filters;
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.pos.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                var hasGetVariable = location.search.indexOf('filter=') >= 0;
                if (hasGetVariable) {
                    window.eventBus.$emit('filter-bar-changed',getParameterByName('filter'),this.filters[getParameterByName('filter')]);
                    this.filtered = getParameterByName('filter');
                }

                if (this.is_filtered) {
                    params.filter = this.filtered;
                }

                if (_.isObject(this.sort)) {
                    params.sort_by = this.sort.field;
                    params.sort_dir = this.sort.direction;
                }

                if (this.supplierId) {
                    params.supplier_id = this.supplierId;
                    params.supplier_type = this.supplierType;
                }

                that.items = [];

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.statuses = response.data.meta.statuses;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('filter-bar-changed',function(value){
               that.filtered = value;
            });

            window.eventBus.$on('sort-widget-po', function(sortObject){
                that.sort = sortObject;
                that.getItems();
            });

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
